<script setup>
defineProps(['error', 'classes']);
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
    <v-tooltip location="bottom" content-class="tooltip-error">
        <template v-slot:activator="{ props }">
            <v-icon
                v-bind="props"
                color="error"
                icon="mdi-close-network"
                :class="classes"
            ></v-icon>
        </template>

        {{ t(error) }}
    </v-tooltip>
</template>

<style lang="scss" scoped>
:deep(.tooltip-error) {
    background-color: #f5dfe3 !important;
    color: #252525 !important;
    border: 1px solid #b00020;
}
</style>
